import styled from 'styled-components';

export const Nav = styled.nav`
  background: #161B22;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  height: 60px;
  width: 100%;
  padding: 5;
  position: fixed;
  top: 0;
  z-index: 1000;
`;


